import { render, staticRenderFns } from "./course.vue?vue&type=template&id=6b7789c6&scoped=true&"
import script from "./course.vue?vue&type=script&lang=js&"
export * from "./course.vue?vue&type=script&lang=js&"
import style0 from "./course.vue?vue&type=style&index=0&id=6b7789c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7789c6",
  null
  
)

export default component.exports